import { forEach, without, cloneDeep, isEmpty } from 'lodash'

export default {
  setFilterSchema (state, schema) {
    state.schema = schema
    let selections = {}
    forEach(schema, table => {
      if (isEmpty(selections[table.table_name])) {
        selections[table.table_name] = {}
      }
      forEach(table.filter_columns, column => {
        selections[table.table_name][column.column_name] = {
          display_name: column.display_name,
          tableau_name: column.tableau_name,
          values: [],
          isInControlArea: false
        }
      })
    })
    // Vuex should make entire objects reactive on assignment like this.
    state.selections = cloneDeep(selections)
  },
  setFilterCounts (state, counts) {
    state.counts = counts
  },
  setSelection (state, payload) {
    state.selections[payload.table][payload.column].values = payload.selections;
    // state.selections[payload.table][payload.column], 'values', payload.selections
    state.applied = false
  },
  setSelectionIsInControlArea (state, payload) {
    state.selections[payload.table][payload.column].isInControlArea = payload.isInControlArea
    // state.selections[payload.table][payload.column], 'isInControlArea', payload.isInControlArea
  },
  setSelectionForTable (state, payload) {
    forEach(payload.selections, selection => {
      state.selections[payload.tableName][selection.column_name].values = selection.values
    })
  },
  clearSelections (state) {
    forEach(state.schema, table => {
      forEach(table.filter_columns, column => {
        state.selections[table.table_name], column.column_name, {}
        state.selections[table.table_name][column.column_name].display_name = column.display_name
        state.selections[table.table_name][column.column_name].tableau_name = column.tableau_name
        state.selections[table.table_name][column.column_name].values = []
        state.selections[table.table_name][column.column_name].isInControlArea = false
      })
    })
  },
  setSelections (state, selections) {
    state.selections = cloneDeep(selections)
  },
  removeFromSelection (state, payload) {
    state.selections[payload.table][payload.column], 'values', without(state.selections[payload.table][payload.column].values, payload.value)
    state.applied = false
  },
  setApplied (state, value) {
    state.applied = value
  },
  setInapplicability (state, applicability) {
    state.inapplicability = applicability
  },
  setFilterOpen (state, status) {
    state.filterOpen = status
  },
  setOpenFilter (state, filter) {
    state.openFilter = filter
  },
  clear (state) {
    state.schema = {}
    state.counts = {}
    state.selections = {}
    state.lastAppliedFilters = {}
    state.openFilter = {}
    state.filterOpen = false
    state.applied = true
  },
  clearLastAppliedFilters (state) {
    state.lastAppliedFilters = {}
  },
  setLastAppliedFilters (state) {
    // make sure selections are set in state before calling this mutation.
    state.lastAppliedFilters = cloneDeep(state.selections)
  },
  updateSessionCache(state, payload) {
    // Merge new selections into the cache without wiping other tables
    forEach(payload, (tableData, tableName) => {
      // Ensure the table object exists in cache
      if (!state.sessionCache[tableName]) {
        state.sessionCache[tableName] = {}
      }
      forEach(tableData, (colData, colName) => {
        // Update/Overwrite specific column data
        state.sessionCache[tableName][colName] = colData
      })
    })
  },
  clearSessionCache(state) {
    state.sessionCache = {}
  }
}
